import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=abed6688&scoped=true"
import script from "./BaseLogo.vue?vue&type=script&lang=ts"
export * from "./BaseLogo.vue?vue&type=script&lang=ts"
import style0 from "./BaseLogo.vue?vue&type=style&index=0&id=abed6688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abed6688",
  null
  
)

export default component.exports